
import Button from '../../../components/base/Button';

export default function ProgramsSection() {
  const programs = [
    {
      title: 'Infants',
      age: '6 weeks - 12 months',
      description: 'Gentle care and early sensory development in a nurturing environment designed for our youngest learners.',
      features: ['Individualized care schedules', 'Sensory play activities', 'Milestone tracking', 'Parent communication'],
      image: 'https://public.readdy.ai/ai/img_res/93710591fee2a6303b7f47d642afd30a.jpg',
      color: 'bg-[#FFD84C]/10'
    },
    {
      title: 'Toddlers',
      age: '12 months - 2 years',
      description: 'Active exploration and language development through structured play and social interaction.',
      features: ['Language development', 'Motor skill building', 'Social interaction', 'Creative expression'],
      image: 'https://readdy.ai/api/search-image?query=Bright%20toddler%20classroom%20with%20age-appropriate%20toys%2C%20small%20tables%20and%20chairs%2C%20toddlers%20playing%20with%20blocks%20and%20puzzles%2C%20teacher%20supervising%2C%20warm%20educational%20environment&width=400&height=300&seq=toddler1&orientation=landscape',
      color: 'bg-[#2E5939]/10'
    },
    {
      title: 'Preschool',
      age: '3 - 4 years',
      description: 'Structured learning activities that prepare children for kindergarten while fostering creativity.',
      features: ['Pre-academic skills', 'Creative arts & crafts', 'Group activities', 'Independence building'],
      image: 'https://readdy.ai/api/search-image?query=Vibrant%20preschool%20classroom%20with%20learning%20centers%2C%20children%20engaged%20in%20art%20activities%2C%20alphabet%20wall%2C%20educational%20posters%2C%20teacher%20guiding%20students%2C%20bright%20natural%20lighting&width=400&height=300&seq=preschool1&orientation=landscape',
      color: 'bg-[#FFD84C]/10'
    },
    {
      title: 'Pre-K',
      age: '4 - 5 years',
      description: 'Comprehensive kindergarten preparation with advanced learning concepts and school readiness skills.',
      features: ['Kindergarten readiness', 'Early literacy & math', 'Problem solving', 'Leadership skills'],
      image: 'https://readdy.ai/api/search-image?query=Advanced%20pre-kindergarten%20classroom%20with%20children%20working%20on%20educational%20activities%2C%20writing%20practice%2C%20math%20manipulatives%2C%20reading%20corner%2C%20teacher%20instruction%2C%20school%20preparation%20environment&width=400&height=300&seq=prek1&orientation=landscape',
      color: 'bg-[#2E5939]/10'
    }
  ];

  return (
    <section className="py-20 bg-[#FFF9F1]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 
            className="text-3xl md:text-4xl font-bold text-[#2E5939] mb-6"
            style={{ fontFamily: '"Poppins", sans-serif' }}
          >
            Age-Appropriate Programs
          </h2>
          <p 
            className="text-xl text-[#2B2B2B]/80 max-w-3xl mx-auto leading-relaxed"
            style={{ fontFamily: '"Open Sans", sans-serif' }}
          >
            Each program is carefully designed to meet the developmental needs of children at every stage of their early years.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {programs.map((program, index) => (
            <div 
              key={program.title}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`${program.color} p-6`}>
                <img 
                  src={program.image}
                  alt={`${program.title} program`}
                  className="w-full h-48 object-cover object-top rounded-xl shadow-md"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 
                    className="text-2xl font-bold text-[#2E5939]"
                    style={{ fontFamily: '"Poppins", sans-serif' }}
                  >
                    {program.title}
                  </h3>
                  <span 
                    className="bg-[#FFD84C] text-[#2B2B2B] px-3 py-1 rounded-full text-sm font-medium"
                    style={{ fontFamily: '"Open Sans", sans-serif' }}
                  >
                    {program.age}
                  </span>
                </div>
                <p 
                  className="text-[#2B2B2B]/80 mb-4 leading-relaxed"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  {program.description}
                </p>
                <ul className="space-y-2 mb-6">
                  {program.features.map((feature, idx) => (
                    <li 
                      key={idx}
                      className="flex items-center text-[#2B2B2B]/70"
                      style={{ fontFamily: '"Open Sans", sans-serif' }}
                    >
                      <div className="w-2 h-2 bg-[#FFD84C] rounded-full mr-3"></div>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Button 
                  variant="outline" 
                  size="sm"
                  onClick={() => {
                    window.open('https://calendar.app.google/sG5oJhDdEq2U5GKn6', '_blank');
                  }}
                >
                  Learn More
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => {
                if (window.REACT_APP_NAVIGATE) {
                  window.REACT_APP_NAVIGATE('/programs');
                }
              }}
            >
              View All Programs
            </Button>
            <Button 
              variant="secondary" 
              size="lg"
              onClick={() => {
                if (window.REACT_APP_NAVIGATE) {
                  window.REACT_APP_NAVIGATE('/admissions');
                }
              }}
            >
              Enroll Now
            </Button>
          </div>
        </div>

      </div>
      
      {/* Soft Section Divider */}
      <div className="mt-20">
        <div className="h-px bg-gradient-to-r from-transparent via-[#2E5939]/20 to-transparent"></div>
      </div>
    </section>
  );
}
